import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 360px;
`;

export const NodeContext = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerLowest ?? '#07080F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: ${({ theme: { borderRadius = {} } }) =>
    borderRadius.small ?? '6px'};
`;

export const NodeLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;

export const NodeInstructions = styled.div`
  font-size: 12px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  white-space: pre-wrap;
`;

export const ReviewFiles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;

export const CommentField = styled.textarea`
  width: 100%;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerLowest ?? '#07080F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: ${({ theme: { borderRadius = {} } }) =>
    borderRadius.extrasmall ?? '4px'};
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
  font: inherit;
  font-size: 13px;
  padding: 8px 10px;
  outline: none;
  resize: vertical;
  min-height: 70px;

  &:focus {
    border-color: ${({ theme: { colors = {} } }) =>
      colors.primary ?? '#C1C1FF'};
  }
`;

export const RoleHint = styled.div`
  font-size: 11px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  font-style: italic;
`;
